import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EnterpriseContext from './Enterprise.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { BUSINESS_ROUTE } from 'data/global';
import FourDotLoader from 'components/FourDotLoader';
import api from 'api';
import useEnterpriseBrokers from 'hooks/useEnterpriseBrokers';
import useBusinessUnits from 'hooks/useBusinessUnits';
import useEnterprise from 'hooks/useEnterprise';

const EnterpriseProvider: React.FC = (props) => {
  const { children } = props;

  const { enterprise: usersEnterprise } = useContext(CurrentUserContext);

  const { id } = useParams();

  const {
    enterprise,
    isMyEnteprise,
    setEnterprise,
    updateEnterprise,
    updateBusinessUnits,
    updateMemberSeniorities,
    updateMemberLocations,
  } = useEnterprise(id);

  const brokers = useEnterpriseBrokers(enterprise);
  const { businessUnitsOptions } = useBusinessUnits(enterprise?.businessUnits);

  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate(BUSINESS_ROUTE, { replace: true });
      return;
    }

    if (id === enterprise?._id) return;

    if (isMyEnteprise) {
      setEnterprise(usersEnterprise);
      return;
    }

    (async () => {
      try {
        const { data } = await api.enterprises.getEnterprise(id);
        setEnterprise(data);
      } catch (e) {
        return;
      }
    })();
  }, [
    enterprise?._id,
    id,
    isMyEnteprise,
    navigate,
    setEnterprise,
    usersEnterprise,
  ]);

  return (
    <EnterpriseContext.Provider
      value={{
        enterprise,
        units: businessUnitsOptions,
        brokers,
        updateEnterprise,
        updateBusinessUnits,
        updateMemberSeniorities,
        updateMemberLocations,
      }}
    >
      {enterprise ? children : <FourDotLoader />}
    </EnterpriseContext.Provider>
  );
};

export default EnterpriseProvider;
